import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles.css';
import IntroLandingV2 from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <IntroLandingV2 />
  </React.StrictMode>
);
